import type { CastListMarkerInfo } from './computeListMarkers';
import type { AlineContentBlock, ParagraphElement, TableElement } from '../../slate-api';
import type { CastBlockContent, CastTable, CastTableCell, CastTableRow } from '../types';

export function extractCastFromTable(
  table: TableElement,
  listMarkers: Map<ParagraphElement, CastListMarkerInfo>,
  extractCastFromContentBlocks: (
    blocks: AlineContentBlock[],
    listMarkers: Map<ParagraphElement, CastListMarkerInfo>
  ) => CastBlockContent[]
): CastTable {
  const rows: CastTableRow[] = [];
  for (const tableRow of table.children) {
    const cells: CastTableCell[] = [];
    for (const tableCell of tableRow.children) {
      const children = extractCastFromContentBlocks(tableCell.children, listMarkers);
      cells.push({ children, type: 'tableCell' });
    }
    rows.push({ children: cells, id: tableRow.locationId ?? '', type: 'tableRow' });
  }
  return { children: rows, id: table.locationId ?? '', type: 'table' };
}
